module.exports = __webpack_public_path__ + "static/media/down-arrow.a5aff2e9.svg";